import React, { useState } from "react";
import { Table } from "reactstrap";

const DynamicTable = ({ data}) => {
   
        const columns = Object.keys(data[0]);
      
    return(
        <div className="mld-third-fold pt-2 pb-4 bg-color-blue">
        <div className="table-wrapper">
             <p className='main-title text-center'>Issue Structure</p>
        <Table striped bordered className="trans-table">
            <thead>
            <tr className="table-header">
                {columns.map((column) => (
                  <th key={column}>{column}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {data.map((item) => (
                <tr key={item.Series}>
                  {columns.map((column) => (
                    <td key={column}>{item[column]}</td>
                  ))}
                </tr>
              ))}
            </tbody>
          </Table>
    </div>
    </div>
    )
}

export default DynamicTable